import React, { useEffect, useRef } from "react";
import InjectScript from "../CustomScript";
import ReactGA from "react-ga4";

const RelatedGalleryItem = React.forwardRef(({
  data,
  isExpanded,

}, ref) => {
  const imagesRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute("id");
            window.history.replaceState(null, "", `/${data.url}?${id}`);

            window._comscore = window._comscore || [];
            window._comscore.push({
              c1: "2",
              c2: "38736750",
              page: `/${data.url}?${id}`,
            });

            if (window.COMSCORE && window.COMSCORE.beacon) {
              window.COMSCORE.beacon({
                c1: "2",
                c2: "38736750",
                page: `/${data.url}?${id}`,
              });
            }

            ReactGA.send({
              hitType: "pageview",
              page: `/${data.url}?${id}`,
              title: "Gallery",
            });
          }
        });
      },
      { threshold: 0.6 }
    );

    imagesRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      if (imagesRef.current) {
        imagesRef.current.forEach((el) => {
          if (el) observer.unobserve(el);
        });
      }
    };
  }, [isExpanded, data]);

  return (
    <div
      ref={ref}
      data-url={data.url}
      className={`story article-${data.id}`}
    >
      <div className="shadow p-3 mb-3 bg-white rounded">
        <h1 className="gallery-head-title">{data.title}</h1>
        <div className="post-content-gallery">
          <InjectScript
            script={(data?.short_description?.trim()
              ? data.short_description
              : data?.content
            )
              ?.replace("[[$ad]]", "")
              ?.replace("[[$googlead]]", " ")
              ?.replace("[[$alsoread]]", " ")}
          />
        </div>
      </div>
      {data?.images?.map((img, index) => (
        <React.Fragment key={img.image_id}>
          <div
            id={`${img.image_id}`}
            ref={(el) => (imagesRef.current[index] = el)}
            style={{}}
          >
            <>
              <div
                className="card mb-3 scrollValue"
                id={`myGalleyImg${data.id}_${index + 1}`}
                data-index={index + 1}
              >
                <span className="sticky-num">
                  {index + 1}
                  <em>/{data?.images?.length}</em>
                </span>
                <img
                  loading="lazy"
                  className="card-img-tops"
                  src={`${img?.media}`}
                  alt={img?.media_title}
                />
              </div>
              <p
                className="mb-2 mt-2"
                style={{ fontSize: "17px" }}
                dangerouslySetInnerHTML={{
                  __html: img.content,
                }}
              />
            </>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
});

export default RelatedGalleryItem;
